<script>
  import { AdServiceWrapper } from '@/services/wrapper/adServiceWrapper'

  /**
   * The ad component represents container for advertisements filled by AdService
   * @vue-prop {string} tagId the service-slot name of the ad
   * @vue-prop {boolean} autoLoad load the ad automatically on mount via the AdService
   */
  export default {
    props: {
      tagId: {
        type: String,
        required: true
      },
      autoLoad: {
        type: Boolean,
        default: true
      }
    },
    mounted () {
      const _this = this

      this.$nextTick().then(() => {
        // on first call the AdService may not be initialized at this point.
        // nevertheless we need it only on resize and following renderings
        try {
          window.AdService?.trigger(
            'ad.property.nextTagId',
            window.AdService?.AdSlot(_this.tagId),
            { 'nextTagId': window.AdService?.getDefaultAdServer()?.params?.tagid(window.AdService?.AdSlot(_this.tagId)) || _this.tagId }
          )
          window.AdService?.AdSlot(_this.tagId)?.setDomNode(_this.$el)
        } catch (error) {}

        _this.autoLoad && AdServiceWrapper.makeAd(_this.tagId)
      })
    }
  }
</script>

<template>
  <div :data-service-slot="tagId"></div>
</template>
